import React, {useEffect, useState} from 'react';
import styled from 'styled-components';
import {Contents} from "../../../components";
import CloseGrey from "../../../../assets/images/icon/CloseGrey";
import CloseIcon from "../../../../assets/images/icon/CloseIcon";
import {teachersAPI} from "../../../../api/teachersAPI";

const ProfileUrlPopup = (props) => {
    const [render, setRender] = useState(false);

    useEffect(() => {
        setRender(true)
    }, []);
return(
    <Container className={render ? "on" : ""}>
        <Contents title={"Profile URL"}>
            <Inner>
                <h1>Edit your custom URL</h1>
                <h2>Personalize the URL for your profile.</h2>
                <Content>
                    <span>www.whoflex.com/instructors/</span><input
                    value={props.value}
                    onChange={(e)=>{props.onChange(e);}}
                    type="text"/>
                </Content>
                <p>
                    <b>Note</b>: Your custom URL must contain 03 - 100 letters or numbers.
                </p>
                <p>
                    <b>Please</b>: Your custom URL must contain 03 - 100 letters or numbers.
                </p>
                <Btn>

                    <span
                        onClick={()=>{
                            props.onClickSave();
                            props.onClickPopup();
                        }}
                        style={{
                        background: "#333",
                        color: "#fff"
                    }}>
                      Save
                  </span>
                </Btn>
            </Inner>
            <div
                onClick={()=>{
                    props.onClickPopup();
                }}
                className="closeButton">
               <CloseIcon/>
            </div>
        </Contents>

    </Container>
)

}
export default ProfileUrlPopup;

const Container = styled.div`
    transition: all 0.3s;
    opacity: 0;
    transform: translateY(16px);
    &.on{
        opacity: 1;
        transform: none;
    }
    position: relative;
    .commonContentsHeader{
        padding-left: 15px;
    }
    .closeButton{
        width: 22px;
        height: 22px;
        cursor: pointer;
        display: flex;
        align-items: center;
        z-index: 9999999;
        position: absolute;
        right: 10px;
        top:10px
    }
    @media screen and (max-width: 768px) {
        width: 90%;
        margin: auto;
        @supports (-webkit-touch-callout: none) {
            /* Safari 스타일 */
            width: calc(100vw - 40px);
        }
    }
    //width: 90%;
    max-width: 500px;
    //width: 490px;
    h1{
        font-family: Europa-Bold;
        font-size: 22px;
        font-weight: 700;
        line-height: 22px;
        letter-spacing: 0em;
        text-align: left;
        margin-bottom: 15px;
    }
    h2{
        font-family: Europa-Regular;
        font-size: 18px;
        font-weight: 400;
        line-height: 18px;
        letter-spacing: 0em;
        text-align: left;
        margin-bottom: 22px;
    }
    p{
        b{
            font-family: Europa-Bold;
            font-size: 14px;
            font-weight: 700;
            line-height: 20px;
            letter-spacing: 0em;
            text-align: left;
        }

        font-family: Europa-Regular;
        font-size: 14px;
        font-weight: 400;
        line-height: 20px;
        letter-spacing: 0em;
        text-align: left;

    }
`;
const Content = styled.div`
    margin-bottom: 16px;
    span{
        font-family: Europa-Regular;
        font-size: 18px;
        font-weight: 400;
        line-height: 18px;
        letter-spacing: 0em;
        text-align: left;

    }
   input{
       border: none;
       border-bottom: solid 1px #333!important;
       outline: none;
       font-family: Europa-Bold;
       font-size: 18px;
       font-weight: 700;
       line-height: 18px;
       letter-spacing: 0em;
       text-align: left;

   }
`
const Inner = styled.div`
    padding: 15px;
`
const Btn = styled.div`
   display: flex;
   justify-content: flex-end;
    margin-top: 30px;
   span{
       margin-left: 20px;
       display: flex;
       align-items: center;
       justify-content: center;
       font-family: Europa-Regular;
       font-size: 20px;
       font-weight: 400;
       line-height: 26px;
       letter-spacing: 0em;
       text-align: left;
       padding: 6.5px 20.5px;
       border: 1px solid rgba(51, 51, 51, 1);
       width: 100px;
       border-radius: 5px;
       cursor: pointer;
   }
`